import { get, deleteRequest, post } from './api'

import { getServerInfo } from '../utils/helpers/networkInfo.helper'

const serverUrl = getServerInfo('api')

export class SchedulerService {
  static getAll(token, queryParams = {}) {
    return get(`${serverUrl}scheduler`, token, queryParams)
  }

  static getById(id, token) {
    return get(`${serverUrl}scheduler/${id}`, token)
  }

  // ✅ NUEVO MÉTODO: Obtener historial del usuario autenticado
  static getMyHistory(token) {
    return get(`${serverUrl}scheduler-history`, token)
  }

  static getAvaiblePod(startDate, endDate, idPod, token) {
    return get(
      `${serverUrl}schedulerAvailable?startDate=${startDate}&endDate=${endDate}&pod_id=${idPod}`,
      token
    )
  }

  static delete(id, token) {
    return deleteRequest(`${serverUrl}scheduler/${id}`, null, false, token)
  }

  static create(data, token) {
    return post(`${serverUrl}scheduler`, data, true, token)
  }

  static getByDay(startDate, laboratory_id, token, options = {}) {
    const queryParams = {
      startDate: startDate,
      laboratory_id: laboratory_id,
    }

    if (options.signal) {
      queryParams.signal = options.signal
    }

    return get(`${serverUrl}scheduler`, token, queryParams)
  }

  static getpodsForUserandLab(user_id, laboratory_id, token) {
    return get(`${serverUrl}schedulerpods?user_id=${user_id}&laboratory_id=${laboratory_id}`, token)
  }

  static getSchedulerByUser(userId, token) {
    return get(`${serverUrl}scheduler/user/${userId}`, token)
  }

  static getSessionRecords(schedulerId, token) {
    return get(`${serverUrl}session-records/scheduler/${schedulerId}`, token)
  }

  static getSessionRecordsByVM(schedulerId, vmId, token) {
    return get(`${serverUrl}session-records/scheduler/${schedulerId}/vm/${vmId}`, token)
  }
}
